// src/context/AdminNotificationsContext.jsx
// Monte le hook UNE SEULE FOIS pour toutes les pages admin.
// Survit aux navigations entre /admin, /admin/terrain, etc.

import { useAdminNotifications } from '@/hooks/useAdminNotifications';
import { createContext, useContext } from 'react';

const AdminNotificationsContext = createContext(null);

export function AdminNotificationsProvider({ children }) {
  const value = useAdminNotifications();
  return (
    <AdminNotificationsContext.Provider value={value}>
      {children}
    </AdminNotificationsContext.Provider>
  );
}

export function useAdminNotificationsContext() {
  return useContext(AdminNotificationsContext);
}